<template>
  <div class="app-container">
    <navigation></navigation>
    <div v-if="isLogin" class="not-login">
      <button @click="login">登录/注册</button>
      <p>点击登录，享受更多精彩信息！</p>
    </div>
    <div v-else>
      <div class="card">
        <div class="per-card-cont">
          <ul>
            <li>
              <p class="name-tel" v-if="userInfo">
                <span class="name">{{ userInfo.cn?userInfo.cn:'读者' }}
                  <img src="@/assets/img/certification.png" alt="" v-if="userInfo.rcardid && userInfo.idno">
                  <i v-if="userInfo.rcardid">读者卡用户</i>
                  <i v-else-if="userInfo.idno">实名认证用户</i>
                </span>
                <span>{{ userInfo.mobile?userInfo.mobile:'' }}</span>
              </p>
              <p class="set" @click="completeMessgae">
                完善个人信息
              </p>
            </li>
            <li class="num-integral">
              <p class="id-card" v-if="userInfo.rcardid">读者卡号：{{ userInfo.rcardid }}</p>
              <p class="integral" v-if="JSON.stringify(list).indexOf(JSON.stringify('积分记录')) !== -1">
                <span class="message">当前积分</span>
                <span class="num">123</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="list list-svg">
        <van-cell is-link v-for="item in list" center @click="goDetail(item.to)">
          <template #title>
            <svg-icon :iconClass='item.icon' className='pre-icon'></svg-icon>
            <span class="custom-title">{{ item.dictName }}</span>
          </template>
        </van-cell>
      </div>
      <div class="list list-update">
        <van-cell is-link center @click="updatePassword">
          <template #title>
            <svg-icon iconClass='update' className='pre-icon'></svg-icon>
            <span class="custom-title">修改密码</span>
          </template>
        </van-cell>
        <van-cell is-link center to="messageBoard">
          <template #title>
            <svg-icon iconClass='message' className='pre-icon'></svg-icon>
            <span class="custom-title">联系我们</span>
          </template>
        </van-cell>
      </div>
      <div class="list list-exit">
        <van-cell v-if="!userInfo.rcardid" is-link center @click="isLogout=true" value="注销后无法恢复,请谨慎操作">
          <template #title class="custom-value">
            <svg-icon iconClass='logout' className='pre-icon'></svg-icon>
            <span class="custom-title">注销账号</span>
          </template>
        </van-cell>
        <van-cell is-link center @click="exit">
          <template #title>
            <svg-icon iconClass='exit' className='pre-icon'></svg-icon>
            <span class="custom-title">退出登录</span>
          </template>
        </van-cell>
      </div>
    </div>
    <van-tabbar v-model="active" class="personal-tab" ref="tab">
      <van-tabbar-item to="/">
        <span>首页</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="resource">
        <span>资源</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="information">
        <span>资讯</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item  to="personal">
        <span>个人中心</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <version v-if="isLogin" type="position"></version>
    <version v-else></version>
    <van-overlay :show="isLogout">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p>
            <span>注销后无法恢复</span>
            <span>是否继续注销账号</span>
          </p>
          <div class="logout-btn">
            <van-button type="primary" class="cancel" @click="isLogout=false">取消</van-button>
            <van-button type="primary" class="confirm" @click="logoutConfirm">确认注销</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from 'vue'
import navigation from '../../components/navigation'
import {Tabbar, TabbarItem, NavBar, Cell, CellGroup, Dialog, Toast} from 'vant'
import {request} from '../../untils/request'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'personal',
  components: {navigation, version},
  data () {
    return {
      active: 3,
      userInfo:this.$store.state.userInfo,
      list: [],
      isLogin: true,
      isShowList:[],
      isLogout: false
    }
  },
  created () {
    Toast.loading({
      message: '加载中...'
    });
    window.scroll(0, 0)
    // 判断是否登录
    console.log('是否有accessToken', this.$cookies.get('accessToken'))
    if (this.$cookies.get('accessToken')) {
      this.isLogin = false
      // 获取显示模块
      this.getModule ()
    } else {
      this.isLogin = true
    }
  },
  mounted() {
    this.isIPhoneX()
    this.$nextTick(()=>{
      Toast.clear()
    });
  },
  methods: {
    // 修改密码
    updatePassword() {
      let tag = this.GetQueryString('tag')
      if(tag==='3d32f4b0'){
        Dialog.alert({
          message: '体验版本，无此功能</br>请手机浏览器打开"http://m.nlc.cn"使用',
        }).then(() => {
          // on close
        });
      } else {
        window.location.href = 'https://sso1.nlc.cn/sso/user/modifyPassword'
      }
    },
    // 完善个人信息
    completeMessgae() {
      let tag = this.GetQueryString('tag')
      if(tag==='3d32f4b0'){
        Dialog.alert({
          message: '体验版本，无此功能</br>请手机浏览器打开"http://m.nlc.cn"使用',
        }).then(() => {
          // on close
        });
      } else {
        window.location.href = 'https://sso1.nlc.cn/sso/user/modifyUser'
      }
    },
    getCtr () {
      request('get', '/nlc-web/api/control/personalCenter').then(res => {
        console.log('是否显示', res)
        const showList = {}
        res.data.forEach(item => {
          var index = item.dictName.lastIndexOf('\-')
          item.dictName = item.dictName.substring(index + 1, item.dictName.length)
          showList[item.dictKey] = item.dictValue
        })
        this.list = [
          {
            icon: 'collection',
            to: 'collection',
            dictName: '我的收藏',
            key: 'MY_COLLECTION'
          },
          {
            icon: 'integral',
            to: 'integral',
            dictName: '积分记录',
            key: 'MY_GOALS'
          },
          {
            icon: 'history',
            to: 'history',
            dictName: '借阅历史',
            key: 'MY_BORROWING_HISTORY'
          },
          {
            icon: 'again',
            to: 'again',
            dictName: '在借信息',
            key: 'MY_BORROWING_INFO'
          },
          {
            icon: 'order',
            to: 'reserve',
            dictName: '预约结果',
            key: 'MY_APPOINTMENT_RESULT'
          },
          {
            icon: 'cartoon',
            to: 'cartoon',
            dictName: '一卡通',
            key: 'MY_CARD'
          }]
        if(this.isShowList.hasOwnProperty('读者指南')){
          this.list.push({
            icon: 'guide',
            to: 'guide',
            dictName: '读者指南',
            key: 'MY_READER_GUIDE'
          })
        }
        this.list = this.list.filter(item => showList[item.key] == 'true')
      })
    },
    // 获取显示模块
    getModule () {
      request('get', '/nlc-web/api/control/module').then(res => {
        console.log('显示模块', res)
        let content = res.data.content
        content.forEach(item => {
          if (item.status === 'SUCCESS') {
            this.isShowList[item.name] = {
              status: item.status,
              sort: item.sort
            }
          }
          this.getCtr()
        })
      })
    },
    login () {
      let url = encodeURI(window.location.href)
      window.location.href = process.env.API_ROOT + '/nlc-api/api/nlc/login?paramUrl='+url
    },

    // 列表点击跳转
    goDetail (link) {
      // this.$router.push({name: link})
      if (this.$store.state.rcardId) {
        this.$router.push({name: link})
      } else {
        if(this.$store.state.uid && link === 'collection'){
          this.$router.push({name: link})
        }else if (link === 'history' || link === 'again' || link === 'reserve' || link === 'cartoon') {
          Dialog.confirm({
            message: '请用读者卡登录？'
          }).then(() => {
            // on confirm
            let url = encodeURI(window.location.href)
            window.location.href = process.env.API_ROOT + '/nlc-api/api/nlc/login?paramUrl='+url
          }).catch(() => {
            // on cancel
          })
        } else {
          this.$router.push({name: link})
        }
      }
    },
    // 确认注销
    logoutConfirm(){
      window.location.href = 'https://sso1.nlc.cn/sso/revoke/apply?callbackurl=http://m.nlc.cn'
      // window.location.href = 'https://192.168.182.149/sso/revoke/apply?callbackurl=http://192.168.182.40'
    },
    // 退出登录
    exit () {
      let tag = this.GetQueryString('tag')
      if(tag==='3d32f4b0'){
        Dialog.alert({
          message: '体验版本，无此功能</br>请手机浏览器打开"http://m.nlc.cn"使用',
        }).then(() => {
          // on close
        });
      } else {
        Dialog.confirm({
          message: '确定退出',
          showCancelButton: true,
        }).then(() => {
          // this.$cookies.remove('accessToken')
          this.$cookies.set("accessToken",'',-1, '/');
          this.$store.commit('changeUid', '')
          this.$store.commit('changeRcardId', '')
          this.$store.commit('changeBalance', '')
          this.$store.commit('changeIdno', '')
          // on confirm
          window.location.href = 'https://sso1.nlc.cn/sso/foreign/authenticate/sso-logout?appId=90052&callback=http%3A%2F%2Fm.nlc.cn%2Fnlc-api%2Fapi%2Fnlc%2Flogout'
        }).catch(() => {
          // on cancel
        })
      }
    },
    // 判断手机是否为iphonex
    isIPhoneX() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height >= 812) {
          //是iphoneX
          console.log('this.$refs.tab.style',this.$refs.tab)
          this.$refs.tab.$el.style.paddingBottom = `${.2}rem`
        }
      }
    },
    // 获取地址栏参数
    GetQueryString(name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  padding-bottom:1.1rem;
  overflow-y:scroll;
  position:relative;
}
.card{
  width:100%;
  height:3.25rem;
  font-size:.28rem;
  font-family: SourceHanSerifCN-SemiBold;
  margin-top:.92rem;
}
.per-card-cont{
  width:6.81rem;
  height:2.8rem;
  padding:.25rem .34rem 0 .35rem;
}
.per-card-cont ul{
  width: 6.81rem;
  height:2.8rem;
  background-size:100% 100%;
  position:relative;
}
.name{
  font-size:.36rem;
}
.name i{
  font-size: .2rem;
  font-family: SourceHanSerifCN-Medium;
  font-style:normal;
  background: linear-gradient(180deg, rgba(255, 233, 183, 0) 0%, rgba(255, 225, 167, 0.8) 36%, #FECE80 100%) no-repeat 0 .13rem;
  background-size:100% 50%;
  padding-left:.05rem;
}
.name img{
  width:.28rem;
  height:.29rem;
  margin-left:.1rem;
  vertical-align: middle;
}
.name-tel{
  padding:.36rem 0 0 .37rem;
  line-height:.4rem;
  height:.8rem;
}
.name-tel span{
  display:block;
}
.set{
  position:absolute;
  right:.48rem;
  top:.1rem;
  font-family: SourceHanSansCN-Regular;
  border-bottom: 1px solid  rgba(71, 73, 76, 0.5);
}
.num-integral{
  position:relative;
  margin-top:.8rem;
  height:1rem;
}
.id-card{
  margin:0;
  padding:.1rem 0 0 .37rem;
}
.user-id{
  position:absolute;
  bottom:0;
}
.integral{
  position:absolute;
  right:.5rem;
  bottom:.3rem;
  margin:0;
}
.integral span{
  display:block;
}
.num{
  font-size:.36rem;
}
.message{
  font-size:.24rem;
  font-family: SourceHanSansCN-Normal;
}
.list{
  width:6.94rem;
  margin:0 .28rem;
  background:#fff;
  font-family: SourceHanSerifCN-Regular;
}
.list-svg{
  border-radius:0 0 8px 8px;
}
.list-update,.list-exit{
  border-radius:8px;
}
.van-cell{
  height:1rem;
  line-height:.6rem;
  border-radius:8px;
}
.not-login{
  width:7.5rem;
  height:13.5rem;
  background:url('../../assets/img/not-login.png') no-repeat;
  background-size:100% 100%;
  text-align: center;
  font-size:.28rem;
  color:#94979C;
}
.not-login button{
  width:3.4rem;
  height:.88rem;
  margin-top:5.61rem;
  font-size:.36rem;
  color:#fff;
  border:none;
  border-radius:60px;
  font-family: SourceHanSerifCN-Bold;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
>>>.van-tabbar-item__icon img{
  width:.56rem;
  height:.56rem;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
}
>>>.van-tabbar{
  height:1.1rem;
}
.list-update{
  margin-top:.16rem;
}
.list-exit{
  margin-top:.16rem;
}
>>>.tip-pos{
  bottom:1.1rem !important;
}
.tabbar-bg{
  width:.56rem;
  height:.56rem;
  display:inline-block;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
  font-family: SourceHanSerifCN-Medium;
}
.custom-title{
  font-size:.28rem;
}
.pre-icon{
  font-size:.28rem;
}
>>>.van-cell__value{
  font-size:.24rem;
  min-width:60%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  width: 5.98rem;
  height: 3.1rem;
  background: #FFFFFF;
  border-radius: .16rem;
  font-size: .36rem;
  font-weight: 600;
  color: #444649;
  text-align:center;
  padding-top:.9rem;
}
.block p{
  margin:0;
  padding:0;
}
.block p span{
  display:block;
}
.logout-btn{
  margin-top:.65rem;
}
.logout-btn button{
  width: 2.46rem;
  height: .88rem;
  border-radius: .6rem;
  border:none;
  font-size: .36rem;
  font-weight: bold;
}
.cancel{
  background: rgba(148, 151, 156, 0.5);
  box-shadow: inset 5px -5px 10px 0px rgba(161, 162, 164, 0.5), inset -5px -5px 10px 0px rgba(231, 233, 235, 0.5);
}
.confirm{
  margin-left:.26rem;
}
</style>



// WEBPACK FOOTER //
// src/view/personal/index.vue